import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';


@Component({
    selector: 'cbm-detail-modal',
    templateUrl: './cbm-detail.component.html',
    styleUrls: ['./cbm-detail.component.scss'],
    standalone: false
})
export class CbmDetailComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() cbmID: string = '';
  @Input() cbmData: any = null;
  @Output() onDismiss: EventEmitter<any> = new EventEmitter();
  @Output() onSelect: EventEmitter<string> = new EventEmitter();
  @Output() onViewAll: EventEmitter<string> = new EventEmitter();
  feedbacks: any[] = [];
  sortType: string = 'Rating';
  expandCities: boolean = false;

  constructor() {}
  ngOnInit() { 
   this.cbmData
  
  }
  dismiss() {
    this.onDismiss.emit();
  }
  select() {
    this.onSelect.emit(this.cbmID);
    this.onDismiss.emit();
  }
  ceil(value: number): number {
    return Math.ceil(value);
  }
  viewAll() {
    this.onViewAll.emit(this.cbmID);
    this.onDismiss.emit();
  }
  // getRating(): number {
  //   return Math.floor(this.cbmData['contractor']['rating'])
  // }
  getReviews(sort = 'Rating' ) {
      const list =  sort === 'Rating' ? this.sortFeedbackByRating() : this.sortFeedbackByDate();
      const res =  [];
      let ctr = 0;
      for (const f of list) {
          if ( ctr >= 5 ) {
            break;
          }
          res.push(f);
          ctr++;
      }
      return res;
  }
  sortFeedbackByRating() {
      const list = this.cbmData['feedback'];
      for (let c = 0 ; c < list.length ; c++) {
          let maxIndex = c;
          let maxRating = this.computeRating(list[c]);
          for (let d = c ; d < list.length; d++) {
            const rating = this.computeRating(list[d]);
            if ( rating > maxRating ) {
                maxRating = rating;
                maxIndex = d;
            }
          }
          const temp = list[c];
          list[c] = list[maxIndex];
          list[maxIndex] = temp;
      }
      return list;
  }
  sortFeedbackByDate() {
      const list = this.cbmData['feedback'];
      for (let c = 0 ; c < list.length ; c++) {
          let maxIndex = c;
          let maxDate = list[c]['date_created'];
          for (let d = c ; d < list.length; d++) {
              const date = list[d]['date_created'];
              if ( date > maxDate ) {
                  maxDate = date;
                  maxIndex = d;
              }
          }
          const temp = list[c];
          list[c] = list[maxIndex];
          list[maxIndex] = temp;
      }
      return list;
  }
  computeRating(feedback: any) {
    const sum = feedback['customer_service'] + feedback['work_quality'] + feedback['response_time'];
    return Math.floor(sum / 3);
  }
 getFeedback():any {
  if (this.cbmData && this.cbmData['feedback']) {
    const list = this.cbmData['feedback'];
    console.log('these are the feedbacks', list);
    return list;
  } else {
    console.log('No feedback data available.');
    return [];
  }
 }
 getRatingValue(rating: string | number): number {
  if (typeof rating === 'string') {
    rating = parseFloat(rating);
  }
  return parseFloat(rating.toFixed(1));
}
getRating(): number {
  return this.cbmData['contractor']['rating'];
}


}
